import React, { useState } from 'react';
import { SignUpOLB, SendFactorForSignUp, VerifyPasscodeForSignUp, RegisterOLB } from 'api';
import { FindMemberForm, FactorSelectionForm, VerifyPasscodeForm } from 'forms';
import { Process, Success } from 'common';
import { useApi } from 'hooks';
import MemberSignUpForm from '../../../forms/memberSignUpForm';

const FindMemberPage = () => {
  const [step, setStep] = useState(1);
  const [member, setMember] = useState();
  const [factors, setFactors] = useState();
  const [stateToken, setStateToken] = useState();
  const [selectedFactor, setSelectedFactor] = useState();

  const [signUpStatus, callSignUpOLB] = useApi(SignUpOLB);
  const [sendStatus, callSendFactor] = useApi(SendFactorForSignUp);
  const [verifyStatus, callVerifyPasscode] = useApi(VerifyPasscodeForSignUp);
  const [registerStatus, callRegisterOLB] = useApi(RegisterOLB);

  const findMember = (accountNumber, ssn) => {
    // MAX: Todo get user info
    callSignUpOLB(accountNumber, ssn).then((data) => {
      if (data?.factor) {
        setMember({ accountNumber, ssn });
        setFactors(data.factor);
        setStateToken(data.stateToken);
        setStep(2);
      }
    });
  };

  const send = (factor) => {
    setSelectedFactor(factor);
    callSendFactor(stateToken, factor).then((data) => {
      if (data) {
        setStateToken(data.stateToken);
        setStep(3);
      }
    });
  };

  const verify = async (passcode) => {
    await callVerifyPasscode(stateToken, selectedFactor, passcode).then((data) => {
      if (data) {
        setStateToken(data.sessionToken);
        setStep(4);
      }
    });
  };

  const register = (login, password, reenter) => {
    callRegisterOLB(stateToken, login, password, reenter, true).then((data) => {
      if (data) {
        setStep(5);
      }
    });
  }

  const isLoading = () => signUpStatus.isLoading || sendStatus.isLoading || verifyStatus.isLoading || registerStatus.isLoading; 

  const error = () => {
    let tempError = false;
    if (signUpStatus.error) tempError = signUpStatus.error;
    if (sendStatus.error) tempError = sendStatus.error;
    if (verifyStatus.error) tempError = verifyStatus.error;
    if (registerStatus.error) tempError = registerStatus.error;
    return tempError;
  };
  // MAX: TODO -> Next step should go to the new sign up page
  return (
    <Process error={error} isLoading={isLoading}>
      {step === 1 && <FindMemberForm forgot={findMember} />}
      {step === 2 && <FactorSelectionForm factors={factors} send={send} />}
      {step === 3 && (
        <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
      )}
      {step === 4 && <MemberSignUpForm signUp={register}/>}
      {step === 5 && (
        <Success header={'Your registration is complete. Click here to sign in.'} href={'/mortgage/sign-in'} />
      )}
    </Process>
  );
};

export default FindMemberPage;
